import { AxiosInstance } from "axios";
import { wrapError } from "../../helpers/utils";
import { Message, MessageIn, MessagesApiFactory } from "./swagger/api";

export interface IApi {
  postMessages(message: MessageIn): Promise<void>;

  getMessages(): Promise<Message[]>;

  putMessage(id: number, message: Message): Promise<Message>;

  getMessageById(id: number): Promise<Message>;

  deleteMessageById(id: number): Promise<void>;
  getActiveMessages(): Promise<Message[]>;
}

const create = (endpoint: string, axiosClient: AxiosInstance) => {
  const messagesApi = MessagesApiFactory(
    { isJsonMime: () => true },
    endpoint,
    axiosClient
  );

  // @ts-ignore
  const postMessages = (message: MessageIn): Promise<void> => {
    const promise: Promise<void> = new Promise((resolve, reject) => {
      messagesApi
        .postMessages(message)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(wrapError(error));
        });
    });
    return promise;
  };

  const getMessages = () => {
    const promise: Promise<Message[]> = new Promise((resolve, reject) => {
      messagesApi
        .getMessages()
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(wrapError(error));
        });
    });
    return promise;
  };

  const putMessage = (id: number, message: Message) => {
    const promise: Promise<Message> = new Promise((resolve, reject) => {
      messagesApi
        .putMessageById(id, message)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(wrapError(error));
        });
    });
    return promise;
  };

  const getMessageById = (id: number) => {
    const promise: Promise<Message> = new Promise((resolve, reject) => {
      messagesApi
        .getMessageById(id)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(wrapError(error));
        });
    });
    return promise;
  };

  const deleteMessageById = (id: number) => {
    const promise: Promise<void> = new Promise((resolve, reject) => {
      messagesApi
        .deleteMessagesById(id)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(wrapError(error));
        });
    });
    return promise;
  };

  const getActiveMessages = () => {
    const promise: Promise<Message[]> = new Promise((resolve, reject) => {
      messagesApi
        .getActiveMessages()
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(wrapError(error));
        });
    });
    return promise;
  };

  return {
    postMessages,
    getMessages,
    putMessage,
    getMessageById,
    deleteMessageById,
    getActiveMessages,
  };
};

export default create;
